import Extend from 'flarum/common/extenders';
import OpportunitiesPage from './components/OpportunitiesPage';
export default [new Extend.Routes().add('devconnect.jobs', '/jobs', OpportunitiesPage).add('devconnect.projects', '/projects', OpportunitiesPage).add('devconnect.events', '/events', OpportunitiesPage)];